import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {
    type CreateAbsenceInput,
    createAbsenceRequestSchema,
    driversForDaySchema,
    type MarkOutOfServiceInput,
    markOutOfServiceRequestSchema,
    outOfServiceSchema,
    publicationSchema,
    publishPreviewSchema,
    type PublishScheduleInput,
    publishScheduleRequestSchema,
    scheduleSummarySchema,
    type SendSummaryInput,
    sendSummaryRequestSchema,
    workerAbsenceSchema,
} from './schemas'

export async function getDriversForDay(date: string) {
    const raw = await apiFetch<unknown>(`/dispatch/drivers?${new URLSearchParams({date})}`)
    return driversForDaySchema.parse(raw)
}

export async function listWorkerAbsences(workerId: string) {
    const raw = await apiFetch<unknown>(`/dispatch/drivers/${workerId}/absences`)
    return z.array(workerAbsenceSchema).parse(raw)
}

export async function createWorkerAbsence(workerId: string, input: CreateAbsenceInput) {
    const body = createAbsenceRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/dispatch/drivers/${workerId}/absences`, {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return workerAbsenceSchema.parse(raw)
}

export async function deleteWorkerAbsence(absenceId: string): Promise<void> {
    await apiFetch<unknown>(`/dispatch/absences/${absenceId}`, {method: 'DELETE'})
}

export async function listOutOfServiceEquipment() {
    const raw = await apiFetch<unknown>('/dispatch/equipment/out-of-service')
    return z.array(outOfServiceSchema).parse(raw)
}

export async function markOutOfService(rentalAssetId: string, input: MarkOutOfServiceInput) {
    const body = markOutOfServiceRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/dispatch/equipment/${rentalAssetId}/out-of-service`, {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return outOfServiceSchema.parse(raw)
}

export async function markBackInService(rentalAssetId: string): Promise<void> {
    await apiFetch<unknown>(`/dispatch/equipment/${rentalAssetId}/back-in-service`, {
        method: 'POST',
    })
}

export async function listPublications(boardDate: string) {
    const raw = await apiFetch<unknown>(
        `/dispatch/publications?${new URLSearchParams({board_date: boardDate})}`,
    )
    return z.array(publicationSchema).parse(raw)
}

export async function publishSchedule(input: PublishScheduleInput) {
    const body = publishScheduleRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/dispatch/publish', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return publicationSchema.parse(raw)
}

export async function previewSchedule(input: PublishScheduleInput) {
    const body = publishScheduleRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/dispatch/publish/preview', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return publishPreviewSchema.parse(raw)
}

export async function listSummaries(boardDate: string) {
    const raw = await apiFetch<unknown>(
        `/dispatch/summaries?${new URLSearchParams({board_date: boardDate})}`,
    )
    return z.array(scheduleSummarySchema).parse(raw)
}

export async function sendSummary(input: SendSummaryInput) {
    const body = sendSummaryRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/dispatch/summary', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return scheduleSummarySchema.parse(raw)
}
